import Component from './order-completed-stripe'

export default Component